import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import {environment} from "../../../../environments/environment";
import { Observable, of } from "rxjs";
import { map, switchMap } from 'rxjs/operators';
const _ = require('lodash');

export enum Client473Statuses {
  open,
  sent,
  closed
}
export enum Client473StatusesLabel {
  'Problemă deschisă',
  'Trimisă la client',
  'Problemă rezolvată'
}

export enum WorksheetTicketSeverity {
  low,
  medium,
  high
}
export enum WorksheetTicketSeverityLabel {
  'Mică',
  'Medie',
  'Mare'
}

export enum WorksheetTicketStatus {
  open = 'open',
  sent = 'sent',
  closed = 'closed',
  solving = 'solving'
}
export enum WorksheetTicketStatusLabel {
  open = 'Deschis',
  sent = 'Răspuns primit',
  closed = 'Închis',
  solving = 'Răspuns, în rezolvare',
}

@Injectable({
  providedIn: 'root'
})
export class WorksheetService {

  private SERVER_URL = `${environment.API_URL}`;

  constructor(private httpClient: HttpClient) { }

  public getWorksheet(clientId: any, month: any, year: any, userId: any) {
    const params = new  HttpParams()
      .set('_clientid', clientId)
      .set('_month', month)
      .set('_year', year)
      .set('_userId', userId);

    return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getWorksheet', {params});
  }

  public getWorksheetHr(clientId: any, month: any, year: any, userId: any) {
        const params = new  HttpParams()
            .set('_clientid', clientId)
            .set('_month', month)
            .set('_year', year)
            .set('_userId', userId);

        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getWorksheetHr', {params});
    }

    public getEmployeesSubtasks() {
        const params = new  HttpParams();

        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getEmployeesSubtasks', {params});
    }

    public getAllowedWorksheetsSummary(userId, month, year, page) {
      const params = new HttpParams()
        .set('userId', userId)
        .set('month', month)
        .set('year', year)
        .set('page', page)

      return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getAllowedWorksheetsSummary', {params})
    }

    public getAllPagesAllowedWorksheetsSummary(userId: string, month: any, year: any): Observable<any[]> {
       const fetchPage = (page: number): Observable<any[]> =>
        this.getAllowedWorksheetsSummary(userId, month, year, page).pipe(
          switchMap((res: any) => {
            if (!res || res?.status === false || !Array.isArray(res?.data) || res?.data?.length === 0 ) {
              return of<any[]>([]);
            }
            return fetchPage(page + 1).pipe(
              map(nextData => [...res?.data, ...nextData])
            );
          })
        ) as Observable<any[]>;

      return fetchPage(1);
    }

    public getWorksheetsSummary(search: any, month: any, year: any): Observable<any> {
        const params = new  HttpParams()
            .set('_search', search)
            .set('_month', month)
            .set('_year', year);

        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getWorksheetsSummary', {params});
    }

    public getSubtasksForTemplate(templateId: any) {
        const params = new  HttpParams()
            .set('templateId', templateId);

        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getSubtasksForTemplate', {params});
    }

    public get473Details(clientId: any, type: any) {
        const params = new  HttpParams()
            .set('clientId', clientId)
            .set('type', type);

        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/get473Details', {params});
    }

    public getTickets(clientId: any) {
        const params = new  HttpParams()
            .set('clientId', clientId);

        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getTickets', {params});
    }

    public getTicketById(ticketId: any) {
        const params = new  HttpParams()
            .set('ticketId', ticketId);

        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getTicketById', {params});
    }

    public getAllContaTickets(): Observable<any> {
        const params = new  HttpParams();
        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getAllTickets', {params});
    }

    public getTicketsByCoordinatorId(coordinatorId: any): Observable<any> {
        const params = new  HttpParams()
            .set('coordinatorId', coordinatorId);

        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getTicketsByCoordinatorId', {params});
    }

    public getTicketsByUserId(userId: any): Observable<any> {
        const params = new  HttpParams()
            .set('userId', userId);

        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getTicketsByUserId', {params});
    }
    
    public getTicketsCountByUserId(userId: any): Observable<any> {
      const params = new  HttpParams()
          .set('userId', userId);

      return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getTicketsCountByUserId', {params});
    }

    public getTicketsByUserIdPaginated(userId: any, page: number): Observable<any> {
      const params = new  HttpParams()
          .set('userId', userId)
          .set('page', page);

      return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getTicketsByUserIdPaginated', {params});
    }

    public getCanSolveTickets(): Observable<any> {
      const params = new HttpParams();
      return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getCanSolveTickets', { params });
    }


    public getAdminVerifications(): Observable<any> {
      const params = new HttpParams();

      return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getAdminVerifications', { params });
    }

    public deleteDetail(data: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/deleteDetail',
            {
                detailId: data
            },
            { headers });
    }

    public deleteTicket(data: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/deleteTicket',
            {
                ticketId: data
            },
            { headers });
    }

    public setRepetitiveIssue(data: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/setRepetitiveIssue',
            {
                data
            },
            { headers });
    }

    public setAnsweredTicketProcessing(data: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/setAnsweredTicketProcessing',
            {
                data
            },
            { headers });
    }

    public saveDetail(data: any, userId, type: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/saveDetail',
            {
                clientId: data.clientId,
                explicatie: data.explicatie,
                suma_d: data.suma_d,
                suma_c: data.suma_c,
                cont: data.cont,
                cd: data.cd,
                date: data.date,
                search: data.search,
                userId: userId,
                type: type,
            },
            { headers });
    }

    public updateDetail(data: any, userId, type: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateDetail',
            {
                id: data.id,
                clientId: data.clientId,
                explicatie: data.explicatie,
                suma_d: data.suma_d,
                suma_c: data.suma_c,
                cont: data.cont,
                cd: data.cd,
                date: data.date,
                search: data.search,
                status: data.status,
                type: type,
            },
            { headers });
    }

  public getClients() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getClients', {params});
  }

  public getSubtasks() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getSubtasks', {params});
  }

    public getTasks() {
        const params = new  HttpParams();

        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getTasks', {params});
    }

    public getSubtasksForTask(taskId) {
        const params = new  HttpParams().set('taskId', taskId);

        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getSubtasksForTask', {params});
    }

    public getDividendForYear(year: any, clientId: string) {
        const params = new  HttpParams()
            .set('year', year)
            .set('clientId', clientId);

        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getDividendForYear', {params});
    }


  public getTemplates() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getTemplates', {params});
  }

  public addSubtaskToWorksheet(worksheetId, subtaskId, userId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/addSubtaskToWorksheet',
        {
          worksheetId,
          subtaskId,
          userId
        },
        { headers });
  }

    public sendDeclaration(clientId, month, year, subtaskId, value = '1', recipisa) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/sendDeclaration',
            {
                clientId,
                subtaskId,
                month,
                year,
                value,
                recipisa
            },
            { headers });
    }

    public setOnrcAsSentToOnrc(clientId) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/setOnrcAsSentToOnrc',
            {
                clientId
            },
            { headers });
    }

    public updateSubtask(data: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateSubtask',
            {
                id: data.id,
                name: data.name,
                description: data.description,
                subchapterId: data.subchapterId
            },
            { headers });
    }

    public updateTask(data: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateTask',
            {
                id: data.id,
                name: data.name,
                description: data.description
            },
            { headers });
    }

    public deleteSubtask(data: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/deleteSubtask',
            {
                id: data
            },
            { headers });
    }

    public registerSubtask(data: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/registerSubtask',
            {
                taskId: data.taskId,
                name: data.name,
                description: data.description,
                subchapterId: data.subchapterId,
                userId: data.userId
            },
            { headers });
    }

    public registerTask(data: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/registerTask',
            {
                name: data.name,
                description: data.description,
                userId: data.userId
            },
            { headers });
    }

    public registerTemplate(name, description, statuses) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/registerTemplate',
        {
          name,
          description,
          statuses
        },
        { headers });
  }

    public login(username, password) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'auth/auth/login',
            {
                username,
                password
            },
            { headers });
    }

  public updateTemplate(templateId, name, description, statuses) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateTemplate',
        {
            templateId,
            name,
            description,
            statuses
        },
        { headers });
  }

  public updateWorksheetSubtask(worksheetId, subtaskId, value, dataActePrimiteValue, checkboxValueNotNeeded, observationsValue, userId, isNumeric = false) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateWorksheetSubtask',
        {
          worksheetId,
          subtaskId,
          value: isNumeric ? parseFloat(value) : (value ? '1' : '0'),
          dataActePrimiteValue: dataActePrimiteValue,
          valueNotNeeded: checkboxValueNotNeeded ? '1' : '0',
          observationsValue,
          userId,
          isNumeric
        },
        { headers });
  }

    public updateWorksheetSubtaskForEmployee(worksheetId, subtaskId, value, checkboxValueNotNeeded, observationsValue,
                                             userId, employeeId, clientId) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateWorksheetSubtaskForEmployee',
            {
                worksheetId,
                subtaskId,
                value: value ? '1' : '0',
                valueNotNeeded: checkboxValueNotNeeded ? '1' : '0',
                observationsValue,
                userId,
                employeeId,
                clientId
            },
            { headers });
    }

  public updateWorksheetSubtaskBilantInterimar(worksheetId, subtaskId, value, userId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateWorksheetSubtaskBilantInterimar',
        {
          worksheetId,
          subtaskId,
          value,
          userId
        },
        { headers });
  }

    public updateWorksheetDividend(worksheetId, dividend, userId) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateWorksheetDividend',
            {
                worksheetId,
                dividend,
                userId
            },
            { headers });
    }

    public updateWorksheetIntracomunitar(worksheetId, intracomunitar, userId) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateWorksheetIntracomunitar',
            {
                worksheetId,
                intracomunitar,
                userId
            },
            { headers });
    }

    public updateWorksheetSubtaskValue(worksheetId, subtaskId, value, userId) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateWorksheetSubtaskValue',
            {
                worksheetId,
                subtaskId,
                value,
                userId
            },
            { headers });
    }

    public updateWorksheetWorkingPlacesValues(wpValues, worksheetId) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateWorksheetWorkingPlacesValues',
            {
                worksheetId,
                wpValues
            },
            { headers });
    }

    public updateDeclarationSubtask(worksheetId, decl74, decl75, decl77, decl78, decl79,
                                    decl80, decl81, decl117, decl73, decl121, decl120, decl156, decl180, decl211, decl424, decl425) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateDeclarationSubtask',
            {
                worksheetId,
                decl74,
                decl75,
                decl77,
                decl78,
                decl79,
                decl80,
                decl81,
                decl117,
                decl73,
                decl121,
                decl120,
                decl156,
                decl180,
                decl211,
                decl424,
                decl425
            },
            { headers });
    }

    public updateClientObservationValue(clientId, value) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateClientObservationValue',
            {
                clientId,
                value
            },
            { headers });
    }

    public updateDividend(value, worksheetId) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateDividend',
            {
                value,
                worksheetId
            },
            { headers });
    }

    public getAdminVerification(clientId): Observable<any> {
        const params = new HttpParams()
            .set('clientId', clientId);

        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/getAdminVerification', {params});
    }

    public saveAdminVerification(value, clientId, userId, month, year, adminVerificationNotNeeded) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/saveAdminVerification',
            {
                value,
                clientId,
                userId,
                month,
                year,
                adminVerificationNotNeeded
            },
            { headers });
    }

  public deleteTemplate(templateId) {
      const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
      return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/deleteTemplate',
          {
              templateId
          },
          { headers });
  }

  public deleteWorksheetSubtask(worksheetId, subtaskId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/deleteWorksheetSubtask',
        {
          worksheetId,
          subtaskId
        },
        { headers });
  }


    public uploadFile(file, userId, formId) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

        const formData: FormData = new FormData();

        formData.append('file', file, `${file.name}${formId}`);

        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/uploadFile',
            formData, {
                reportProgress: true,
                responseType: 'json'
            });
    }

    public sendTaxesEmail(worksheetId, userId, clientId, toEmail, fromEmail, subject, body, subtasks, files, formId) {
        const params = new  HttpParams()
            .set('worksheetId', worksheetId)
            .set('userId', userId)
            .set('clientId', clientId)
            .set('toEmail', toEmail)
            .set('fromEmail', fromEmail)
            .set('subject', subject)
            .set('body', body)
            .set('subtasks', subtasks)
            .set('files', files)
            .set('formId', formId);

        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/sendTaxesEmail', {params});
    }

    public sendInventoryEmail(userId, clientId, subject, body, files, formId) {
        const params = new  HttpParams()
            .set('userId', userId)
            .set('clientId', clientId)
            .set('subject', subject)
            .set('body', body)
            .set('files', files)
            .set('formId', formId);

        return this.httpClient.get(this.SERVER_URL + 'worksheet/worksheet/sendInventoryEmail', {params});
    }

  public sendCustomEmail(userId, clientEmails, subject, body, files, formId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/sendCustomEmail',
      {
        userId,
        clientEmails,
        subject,
        body,
        files,
        formId
      },
      { headers });
  }

  public send473Email(clientId, userId, clientEmails, ccEmails, subject, body, files, formId, items) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/send473Email',
      {
        clientId,
        userId,
        clientEmails,
        ccEmails,
        subject,
        body,
        files,
        formId,
        items
      },
      { headers });
  }

  public createWorksheet(clientId, templateId, month, year, userId, taxId, tvaId, salId, negotiatedprice) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/createWorksheet',
        {
          clientId,
          templateId,
          month,
          year,
          userId,
          taxId,
          tvaId,
          salId,
          negotiatedprice
        },
        { headers });
  }

    public reapplyTemplate(clientId, templateId, month, year, userId, worksheetId) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/reapplyTemplate',
            {
                clientId,
                templateId,
                month,
                year,
                userId,
                worksheetId
            },
            { headers });
    }

  public getClientsForUser(search: string, userId: string) {
    const params = new  HttpParams()
        .set('_search', search)
        .set('_userid', userId);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClientsForUser', {params});
  }

  public getAllClients() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'client/client/getClients', {params});
  }

  public deleteLog(logId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/deleteLog',
        {logId},
        { headers });
  }

  public getLogsForUser(userId: any, date: any) {
    const params = new  HttpParams()
        .set('_userId', userId)
        .set('_date', date);

    return this.httpClient.get(this.SERVER_URL + 'client/client/getLogsForUser', {params});
  }

  public updateStartEndTime(logId: any, starttime: any, endtime: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateStartEndTime',
        {
          logId,
          starttime,
          endtime,
          start_hour: moment(starttime).format('HH:mm'),
          end_hour: moment(endtime).format('HH:mm')
        },
        { headers });
  }

  public createLog(log: any) {
    const postLog = {
      date: log.label,
      starttime: log.startTime,
      endtime: log.endTime,
      start_hour: moment(log.startTime).format('HH:mm'),
      end_hour: moment(log.endTime).format('HH:mm'),
      observations: '',
      clientId: log.firmId,
      month: moment(log.startTime).format('MM'),
      year: moment(log.startTime).format('YYYY'),
      introducere: '0',
      verificare: '0',
      balanta: '0',
      addedBy: log.userId
    };
    if (!log.endTime) {
      postLog.end_hour = null;
    }
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/createLog',
        postLog,
        { headers });
  }

  public stopLog(log: any, endtime: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/stopLog',
        {
          logId: log.id,
          end_hour: moment(endtime).format('HH:mm'),
          endtime},
        { headers });
  }

  public updateObservation(log: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/updateObservation',
        {
          logId: log.id,
          observation: log.observations},
        { headers });
  }

  public getEmployees() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'client/client/getEmployees', {params});
  }

  public getAllEmployees() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'client/client/getAllEmployees', {params});
  }

  public editClient(clientId: any, value: any, field: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/editClient',
      {value, clientId, field},
      { headers });
  }

  public editIncome(id: string, value: number, assignedDate: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'income/income/editIncome',
      {id, value, assignedDate},
      { headers });
  }

  public saveNegotiatedPrice(value: string, clientId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'income/income/saveNegotiatedPrice',
      {value, clientId},
      { headers });
  }

  public saveContract(clientId: string, contractId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'income/income/saveContract',
      {clientId, contractId},
      { headers });
  }

  public saveTva(clientId: string, tvaId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/saveTva',
      {clientId, tvaId},
      { headers });
  }

  public saveSal(clientId: string, salId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/saveSal',
      {clientId, salId},
      { headers });
  }

  public saveTax(clientId: string, taxId: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'client/client/saveTax',
      {clientId, taxId},
      { headers });
  }

  public exportIncomesWithSelectedColumns(columns: any[], year: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'income/income/exportIncomesWithSelectedColumns',
      {columns: columns.join(','), year},
      { headers });
  }

    public saveSubtasksOrder(subtasks: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/saveSubtasksOrder',
            {
                subtasks: subtasks
            },
            { headers });
    }

    public applyNewSubtask(subtaskId, clientId, month, year) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/applyNewSubtask',
            {
                subtaskId: subtaskId,
                clientId: clientId,
                month: month,
                year: year,
            },
            { headers });
    }

    public sendReminder(worksheetId, userId, clientId) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/sendReminderEmailForDocuments',
            {
                worksheetId,
                userId,
                clientId
            },
            { headers });
    }

    public updateSal(worksheetId: any, salId: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateSal',
            {
                worksheetId,
                salId},
            { headers });
    }

    public updateTax(worksheetId: any, taxId: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateTax',
            {
                worksheetId,
                taxId},
            { headers });
    }

    public updateVat(worksheetId: any, vatId: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateVat',
            {
                worksheetId,
                vatId},
            { headers });
    }

    public updateWorksheetTaxes(worksheet: any) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateWorksheetTaxes',
            { worksheet },
            { headers });
    }

  public set473AsCompete(id473: any) {
      const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
      return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/set473AsCompete',
          {
            id: id473
          },
          { headers });
  }

  public saveTicket(data: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/saveTicket',
      {
        data
      },
      { headers });
  }

  public updateTicket(data: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/updateTicket',
      {
        data
      },
      { headers });
  }

  public closeTicket(data: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/closeTicket',
      {
        data
      },
      { headers });
  }

  public sendChatToTicket(data: any, message: string, userId: string, filename: string = '', fileContent: string | null = null, notifyClient: boolean = true) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });

    return this.httpClient.post(
      this.SERVER_URL + 'worksheet/worksheet/sendChatToTicket',
      {
        data,
        message,
        userId,
        filename,
        fileContent,
        notifyClient,
      },
      { headers },
    );
  }

  public downloadMessageAttachment(fileName: string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'worksheet/worksheet/downloadMessageAttachment',
      { fileName },
      { headers, responseType: 'blob', observe: 'response' as 'body' }
    );
  }
}
